var _ellipse, _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPipeline = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 1.66667,
  cy: 1.66667,
  rx: 1.66667,
  ry: 1.66667,
  transform: "matrix(-4.37114e-08 1 1 4.37114e-08 3.33334 3.3335)",
  stroke: "currentColor",
  strokeWidth: 1.25
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 1.66667,
  cy: 1.66667,
  r: 1.66667,
  transform: "matrix(-4.37114e-08 1 1 4.37114e-08 13.3333 13.3335)",
  stroke: "currentColor",
  strokeWidth: 1.25
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15 13.3335L15 9.16683C15 7.78612 13.8807 6.66683 12.5 6.66683V6.66683C11.1193 6.66683 10 7.78612 10 9.16683L10 10.0002",
  stroke: "currentColor",
  strokeWidth: 1.25
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M5 6.6665L5 11.6665C5 13.0472 6.11929 14.1665 7.5 14.1665V14.1665C8.88071 14.1665 10 13.0472 10 11.6665L10 9.99984",
  stroke: "currentColor",
  strokeWidth: 1.25
})));
export default SvgPipeline;